'use strict';

export default angular
  .module('maestro.directives.components.loaderOverlay', [])
  .directive('appLoaderOverlay', function($compile) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {

        let uniqueId;
        // Set position to relative so the child overlay div will be absolute positioned but bounded by the parent (current element in our case) boundaries
        $(element).css('position', 'relative');

        // Check for list loading overlay
        let isListLoader = $(element).hasClass('list');
        let isSingle = $(element).hasClass('single');
        let overlayElement = '.ppc-loader-overlay';
        let halfPadding = $(element).hasClass('half-loader');
        if (isListLoader) {
          // Generate unique ID to show multiple overlays in one scope
          uniqueId = 'id-' + Math.random().toString(36).substr(2, 16);
          overlayElement = '#' + uniqueId;
        }

        scope.$watch(attr.appLoaderOverlay, function appOverlayWatchAction(value) {
          const existingOverlay = isListLoader ? $(overlayElement).length > 0 : element.find(overlayElement).length > 0;
          let overlay;
          if (value) {
            if (!existingOverlay) {

              // Add element and then add class so it will appear smoothly with animation
              if (isListLoader) {
                overlay = $compile(
                  `<div id="${uniqueId}" class="ui fluid placeholder ${halfPadding ? 'half-top' : 'double-top'}">
                    <div class="image header">
                      <div class="line">{{}}</div>
                      <div class="line"></div>
                    </div>
                    <div ng-show="${!isSingle}" class="image header">
                      <div class="line"></div>
                      <div class="line"></div>
                    </div>
                    <div ng-show="${!isSingle}" class="image header">
                      <div class="line"></div>
                      <div class="line"></div>
                    </div>
                  </div>`)(scope);
                $(element).before(overlay).hide();
              } else {
                overlay = $compile(
                  `<div class="ppc-loader-overlay long-fade long-fade-out">
                  <app-spinner size="2em"></app-spinner>
                </div>`)(scope);
                $(element).append(overlay);
              }

              overlay.offset();
              overlay.addClass('in');
              $(element).css('min-height', '100px');
            }
          } else {
            if (existingOverlay) {

              // Remove class first so it will hide away itself smoothly with animation
              overlay = isListLoader
                ? angular.element(element.prev()[0])
                : angular.element(element.find(overlayElement)[0]);
              if (isListLoader) {
                $(element).show();
              }
              overlay.addClass('out');

              // And then remove element from the DOM
              overlay.remove();
              $(element).css('min-height', 'auto');
            }
          }
        });
      }
    };
  })

  .name;
